import apiClient from '@/core/lib/api-client';
import { SessionData } from '../types';
import { ApiResponse } from '@/core/types';

export const getDataSession = async (
  token: string,
  clientId?: string
): Promise<ApiResponse<SessionData>> => {
  const response = await apiClient.post<ApiResponse<SessionData>>(
    'v4GetUserSession',
    { token, clientId },
    { loadingMessage: 'Authenticating...' }
  );
  console.log('getDataSession response', response);
  // mock data
  // const subscriptionInfo = response.data?.Client?.SubscriptionInfo;
  // if (subscriptionInfo) {
  //   if (!subscriptionInfo.PaymentMethod?.profileId) {
  //     subscriptionInfo.PaymentMethod = null as any;
  //   }
  // }

  // mock subscription info if not exists
  // if (
  //   response.data?.Client
  //   && !response.data?.Client?.SubscriptionInfo?.PaymentMethod
  // ) {
  //   response.data.Client.SubscriptionInfo = {
  //     ...response.data.Client.SubscriptionInfo,
  //     Status: 'no_subscription',
  //     // Status: 'active',
  //     // Status: 'failed_payment',
  //     CurrentPlan: 'Free',
  //     CurrentRoadMapId: '123',
  //     PaymentMethod: {
  //       token: '123',
  //       expiry: '123',
  //       profileId: '123',
  //       cardNumberMask: '************1234',
  //       ExpiryMonth: 12,
  //       ExpiryYear: 2025,
  //       CardHolderName: 'John Doe',
  //       BillingAddress: {
  //         Country: 'USA',
  //         State: 'CA',
  //         City: 'San Francisco',
  //         AddressLine: '123 Main St',
  //         ZipCode: '94105',
  //       },
  //     },
  //   };
  // }

  return response;
};
